import { Controller } from "@hotwired/stimulus"

// Tasks::CommentComposerComponent — PDE-970.
//
// Re-focuses the comment textarea after a successful post so the
// operator can keep composing without clicking the summary again. The
// controller is attached only when the server re-renders the composer
// with `autofocus: true` (i.e. inside the post-success Turbo Stream),
// so the initial drawer paint does not steal focus.
export default class extends Controller {
  static values = { focusOnConnect: Boolean }

  connect() {
    if (this.focusOnConnectValue) {
      this.element.focus()
    }
  }
}
